import type {
  ISubscriptionPresentation,
} from '@/domain/stripe/customer/sub-domains/subscription/presentation/contract/ISubscriptionPresentation'

export class GetSubscriptionErrorPresentation extends Error implements ISubscriptionPresentation {

}
